import { InspectionImageListItem } from "../../_objects/inspection-image";
import { ExifOrientation } from "../../app.constants";

export const rotateImage = (inspectionImage: InspectionImageListItem) => {
  const style = {};
  const rotation = getRotationFromOrientation(inspectionImage.orientation);

  style['transform'] = rotation;
  style['-moz-transform'] = rotation;
  style['-webkit-transform'] = rotation;
  style['-o-transform'] =rotation;
  style['-ms-transform'] = rotation;

  if (inspectionImage.orientation >= ExifOrientation.MirrorHorizontalAndRotate270) {
   
    style['transform'] += `scale(${3 / 4})`;
    style['-moz-transform'] += `scale(${3 / 4})`;
    style['-webkit-transform'] += `scale(${3 / 4})`;
    style['-o-transform'] += `scale(${3 / 4})`;
    style['-ms-transform'] += `scale(${3 / 4})`;
   
  }

  if (inspectionImage.hasModifiedImage) {
    style['object-fit'] = `contain`;
  }

  return style;
};

const getRotationFromOrientation = (orientation: number) => {
  switch (orientation) {
    case ExifOrientation.MirrorHorizontal:
      return 'rotateY(180deg)';
    case ExifOrientation.Rotate180:
      return 'rotate(180deg)';   
    case ExifOrientation.MirrorVertical:
      return 'rotateX(180deg)';
    case ExifOrientation.MirrorHorizontalAndRotate270:
      return 'rotate(90deg) rotateX(180deg)';
    case ExifOrientation.Rotate90:
      return 'rotate(90deg)';
    case ExifOrientation.MirrorHorizontalAndRotate90:
      return 'rotate(270deg) rotateX(180deg)';
    case ExifOrientation.Rotate270:
      return 'rotate(270deg)';
    case ExifOrientation.Default:
    default:
      break;
  }
};